import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../../../services/auth.service';
import { SessionService } from '../../../services/session.service';
import { RequestService } from '../../../services/request.service';
import { ConfigService } from '../../../services/config.service';
import { ProfileService } from '../../profile/profile.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RxComponent } from '../../common/rx.component';
import { NotificationService } from 'app/core/services/notification.service';
import { Router } from '@angular/router';
import { OktaService } from 'app/core/services/okta.service';

declare var $: any;

@Component({
    selector: 'itpx-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    animations: [
        trigger('showNotificationsAnim', [
            transition(':enter', [
                style({ 'max-height': 0 }),
                animate('1s 0.5s ease-out', style({ 'max-height': '1000px' }))
            ]),
            transition(':leave', [
                style({ 'max-height': 1 }),
                animate('0.3s ease-out', style({ 'max-height': '0' }))
            ])
        ]),
        trigger('formAnim', [
            state('0', style({ 'max-height': '2000px' })),
            state('1', style({ 'max-height': '0' })),
            transition('0 => 1', animate('0.5s ease-out')),
            transition('1 => 0', animate('0.5s 0.3s ease-out'))
        ])
    ],
})

export class NavbarComponent extends RxComponent implements OnInit, OnDestroy, AfterViewInit {
    readonly productMarketplaceUrl: string = this.configService.get('server').productMarketplace;
    options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };
    isAuth: boolean;
    userDetails: any;
    details: any;
    defaultAvatar: string;
    isPublic: boolean;
    id: string;
    adminGroup: boolean = false;
    stopProp: boolean = true;
    showNotifications: boolean;
    leapestLogo = this.configService.get('aws').downloadUrl + this.configService.get('images').newWhiteEdcastLogo;
    ioConnection: any;
    activateDirective: boolean;
    instructorProfileLink: string;
    isInstructor = false;
    private domainConfigData = null;

    isUserLoading = true;

    constructor(
        private authService: AuthService,
        private oktaService: OktaService,
        private sessionService: SessionService,
        private requestService: RequestService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private profileService: ProfileService,
        private router: Router,
    ) {
        super();
    }

    async ngOnInit() {
        this.instructorProfileLink = `${this.configService.get('server').instructorMarket}/profile/instructor?leapest-force-login=true`;
        this.defaultAvatar = this.configService.get('links').defaultAvatar;
        this.isAuth = false; // setting the initial state
        this.isPublic = window.location.pathname.indexOf('public') !== -1;
        
        let user;
        try {
            user = await this.oktaService.client.getUser()
        } catch(e) { }
        
        if (user) {
            this.isAuth = true;
            this.userDetails = user;
            this.isUserLoading = false;
            this.isInstructor = user['mkpGroups'] && user['mkpGroups'].find(el => el === 'instructor');
            this.checkUserGroup(user);
            this.authService.setSession();
        }

        this.isUserLoading = false;

        this.domainConfigData = this.configService.getDomainConfigData();
        this.leapestLogo = (
            this.domainConfigData &&
            this.domainConfigData.logo &&
            this.domainConfigData.logo.header &&
            this.domainConfigData.logo.header.url)
            ?
            this.domainConfigData.logo.header.url
            :
            this.leapestLogo;
    };

    login() {
        this.router.navigate(['/login']);
    }

    async logout() {
        await this.authService.logout();
    }

    switchAccount() {
        this.authService.login(undefined, true);
    }


    listSignatories(): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.employees.authorizedSignatoryListJWT.api;
        return this.requestService.get(url);
    }

    checkUserGroup(userData) {
        if (userData && userData['mkpGroups'] &&
            (userData['mkpGroups'].indexOf('administrator') > -1 ||
                userData['mkpGroups'].indexOf('view-administrator') > -1)) {
            this.adminGroup = true;
            this.stopProp = true;
        } else {
            this.adminGroup = false;
        }

    }

    formatDict(obj: any) {
        let result = [];
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                result.push({ key: obj[prop], value: obj[prop] });
            }
        }
        return result;
    }

    get emailWithoutPrefix() {
        const prefix = this.configService.get('okta').prefix;
        return this.userDetails.preferred_username.split(`${prefix}-`)[1];
    }

    // NOTIFICATIONS LOGIC WHICH SHOULD BE EXTRACTED IN A COMPONENT!!!1!!eleven

    ngAfterViewInit() {
        $('.simple-notification-wrapper').css('z-index', 10000);
    };

    stopPropagation(event) {
        if (this.stopProp) {
            event.stopPropagation();
        }
    }

    onShowNotificationList(e: any) {
        e.stopPropagation();
        this.showNotifications = true;
    };

    onMenuDisplay() {
        this.showNotifications = false;
    };

    ngOnDestroy() { }
    // END OF NOTIFICATIONS LOGIC WHICH SHOULDN'T BE HERE!!!1!!eleven
}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/navbar/navbar.component.ts